import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Branch } from 'src/app/models/branch';
import { Paging } from 'src/app/models/page';
import { Product } from 'src/app/models/product';
import { StockAmount } from 'src/app/models/stock-amount';
import { Tax } from 'src/app/models/tax';
import { BranchesService } from 'src/app/services/branches.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductsService } from 'src/app/services/products.service';
import { TaxesService } from 'src/app/services/taxes.service';

@Component({
  selector: 'product-info',
  templateUrl: './product-info.component.html',
})
export class ProductInfoComponent implements OnInit, OnChanges {
  @Input() product = new Product();
  private taxes: Paging<Array<Tax>> = new Paging([]);
  public tax: Tax = new Tax();
  public featureProperties: string[] = [];
  private branches: Array<Branch> | undefined;
  public stockByBranch: Array<StockAmount> | undefined;
  public selectedBranchCode: string | undefined;

  constructor(
    private taxService: TaxesService,
    private configurationService: ConfigurationService,
    private branchService: BranchesService,
    private productService: ProductsService,
  ) { }
  async ngOnChanges(): Promise<void> {
    if (this.product.code) {
      const productDataResponse = this.product;

      this.branches = (await this.branchService.readBranches().toPromise()).response.content;

      this.stockByBranch = productDataResponse.stockBranches.map(stockBranch => {
        const branch = this.branches?.find(b => b.code === stockBranch.branchCode);
        if (branch) {
          stockBranch.branchName = branch.name;
        }
        return stockBranch;
      });
    }
  }

  async ngOnInit(): Promise<void> {
    if (this.product.code) {

      this.taxes = (await this.taxService.readTaxes().toPromise()).response;
      this.tax = this.taxes.content.find(
        (t) => t.code == this.product.taxCode
      ) as Tax;
      this.featureProperties = Object.keys(this.product.features);

      this.selectedBranchCode = this.configurationService.readSelectedBranchAndSalesOrg().branch.code;


    }
  }
}
